<template>
  <div id="index">
    <el-container>
      <el-container>
        <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
          <el-main>
            <nav-bar></nav-bar>

            <el-form
              ref="formselect"
              :model="formselect"
              class="queryform_div"
              label-width="150px"
            >
              <el-row :gutter="24">
                <el-col :md="8" :xs="24" :sm="24">
                  <el-form-item :label="$t('desc.dealername')">
                    <el-input
                      size="small"
                      v-model="formselect.agencyName"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :md="6" :xs="24" :sm="24">
                  <el-form-item :label="$t('title.CooperationStatus')">
                    <el-select
                      v-model="formselect.state"
                      :placeholder="$t('desc.select')"
                      style="width: 100%"
                      size="small"
                    >
                      <el-option value="0" :label="$t('desc.all')"></el-option>
                      <el-option
                        value="1"
                        :label="$t('desc.normal')"
                      ></el-option>
                      <el-option
                        value="2"
                        :label="$t('desc.stoping')"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :md="6" :xs="24" :sm="24" style="margin-top: 10px">
                  <el-button
                    type="primary"
                    @click="getTableList()"
                    size="small"
                    >{{ $t("button.query") }}</el-button
                  >
                  <el-button size="small" @click="resetKeyword">{{
                    $t("button.reset")
                  }}</el-button>
                </el-col>
              </el-row>
            </el-form>
            <template>
              <el-button
                type="primary"
                icon="el-icon-circle-plus-outline"
                @click="showDialog(true)"
                style="margin-bottom: 10px"
                v-show="hasCreateAuth"
                >{{ $t("button.addAgency") }}</el-button
              >
              <el-button
                type="default"
                icon="el-icon-upload2"
                @click="showImportDialog(true)"
                style="margin-bottom: 10px"
                v-show="hasImportAuth"
                >{{ $t("button.bulkImport") }}</el-button
              >
              <el-button
                type="default"
                @click="exportCustomerList()"
                :loading="loading"
                v-if="hasExportAuth"
                style="margin-bottom: 10px"
                >{{ $t("button.exportAgencyList") }}</el-button
              >
              <a
                v-if="activeLang == 'en'"
                class="el-button el-button--default el-button--small"
                style="margin-bottom: 10px; text-decoration: none; float: right"
                href="/file/Excel Import Template -Distributor Managed.xlsx"
                download="Excel Import Template -Distributor Managed.xlsx"
                >{{ $t("desc.exportTemplate") }}</a
              >
              <a
                v-else
                class="el-button el-button--default el-button--small"
                style="margin-bottom: 10px; text-decoration: none; float: right"
                href="/file/EXCEL导入模板-经销商.xlsx"
                download="EXCEL导入模板-经销商.xlsx"
                >{{ $t("desc.exportTemplate") }}</a
              >
              <div class="tableDiv">
                <el-table
                  :data="tableData1"
                  class="table-fixed"
                  stripe
                  style="width: 100%"
                  :empty-text="$t('desc.noData')"
                >
                  <el-table-column
                    type="index"
                    :label="$t('title.serialNumber')"
                    width="60"
                    fixed="left"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="agencyName"
                    :label="$t('desc.dealername')"
                    min-width="200px"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="agencyCode"
                    :label="$t('title.dealercode')"
                    min-width="120px"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="brand"
                    :label="$t('title.brand')"
                    min-width="70px"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="customerCenter"
                    :label="$t('title.customerCenter')"
                    min-width="150px"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="companyType"
                    :label="$t('title.companyType')"
                    min-width="100px"
                  >
                  <template slot-scope="scope">
                    {{ $t("desc."+scope.row.companyType) }}
                  </template>
                  </el-table-column>
                  <el-table-column
                    prop="address"
                    :label="$t('title.address')"
                    min-width="200px"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="stateName"
                    :label="$t('title.CooperationStatus')"
                    min-width="90px"
                  >
                  <template slot-scope="scope">
                    {{ $t("desc."+scope.row.stateName) }}
                  </template>
                    <!-- <template slot-scope="scope">
                    <el-tag
                      :type="
                        scope.row.stateName === '正常' ? 'success' : 'danger'
                      "
                      disable-transitions
                      >{{ scope.row.stateName }}</el-tag
                    >
                  </template> -->
                  </el-table-column>
                  <el-table-column :label="$t('title.operate')" width="110">
                    <template slot-scope="scope">
                      <el-button
                        type="primary"
                        icon="el-icon-edit"
                        :title="$t('button.update')"
                        circle
                        size="mini"
                        v-show="hasUpdateAuth"
                        @click="showEditDialog(true, scope.row.id)"
                      ></el-button>
                      <template>
                        <el-popconfirm
                          placement="top"
                          :confirmButtonText="$t('button.delete')"
                          :cancelButtonText="$t('button.cancel')"
                          icon="el-icon-info"
                          iconColor="red"
                          :title="$t('title.confirmDelete')"
                          @confirm="deleteAge(scope.row.id)"
                        >
                          <el-button
                            type="danger"
                            icon="el-icon-delete"
                            :title="$t('button.delete')"
                            circle
                            size="mini"
                            slot="reference"
                            v-show="hasDeleteAuth"
                          ></el-button>
                        </el-popconfirm>
                      </template>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  background
                  :page-size="pagination.pageSize"
                  :page-sizes="[10, 20, 50]"
                  :current-page.sync="pagination.current"
                  @current-change="handleCurrentChange"
                  @size-change="handleSizeChange"
                  layout="prev, pager, next,sizes"
                  :total="pagination.totalPage"
                  style="text-align: center; margin-top: 10px"
                >
                </el-pagination>
              </div>
            </template>
          </el-main>
        </el-scrollbar>
      </el-container>
    </el-container>
    <cust-dialog
      ref="addRef"
      :refForm="'airFormAdd'"
      :title="(dialogTitle = $t('button.addAgency'))"
      :clientform="clientform"
      :dialogAddClient="dialogAddClient"
      :subButtonAuth="hasCreateAuth"
      :isAdd="(isAdd = true)"
      @onSubBtn="add"
      @dialogVisibleEvent="showDialog"
    >
    </cust-dialog>
    <cust-dialog
      ref="editRef"
      :refForm="'airFormEdit'"
      :title="(dialogTitle = $t('button.updateAgency'))"
      :clientform="clientform"
      :dialogAddClient="dialogEditClient"
      :subButtonAuth="hasUpdateAuth"
      :isAdd="(isAdd = false)"
      :dialogAddMethod="dialogEditMethoud"
      @onSubBtn="update"
      @dialogVisibleEvent="showEditDialog"
    >
    </cust-dialog>
    <import-dialog
      ref="importRef"
      :refForm="'airFormImport'"
      :title="(dialogTitle = $t('button.bulkImportAgency'))"
      :dialogImportClient="dialogImportClient"
      :form="form"
      :loading="importLoading"
      @onSubBtn="uploadFile"
      @dialogVisibleEvent="showImportDialog"
    ></import-dialog>
  </div>
</template>
<script>
import {
  addAgency,
  updateAgency,
  deleteAgency,
  getAgencyList,
  GetCustomerCenterTree,
  getCustomerRegionTree,
  getAgencyById,
  importAgency,
  authOperationCheck,
  exportExcel,
  exportExcelNew,
} from "../../api/api";
import { mapState, mapGetters } from "vuex";
import agencyDialogComponent from "../../components/content/maintabber/AgencyDialog";
import agencyImportComponent from "../../components/content/maintabber/ExportExcelFile";

export default {
  name: "index",
  components: {
    "cust-dialog": agencyDialogComponent,
    "import-dialog": agencyImportComponent,
  },
  computed: {
    ...mapGetters({
      activeLang: "language",
    }),
    ...mapState({
      isCollapse: (state) => state.isCollapse,
      navselected: (state) => state.adminleftnavnum,
    }),
  },
  data() {
    return {
      dialogAddClient: false,
      dialogEditClient: false,
      dialogEditMethoud: false,
      dialogImportClient: false,
      hasUpdateAuth: false,
      hasDeleteAuth: false,
      hasCreateAuth: false,
      hasImportAuth: false,
      hasExportAuth: false,
      loading: false,
      importLoading: false,
      tableData1: [],
      formselect: {
        agencyName: "",
        state: "0",
      },
      clientform: {
        agencyName: "",
        agencyCode: "",
        customerCenter: "",
        regionId: "",
        address: "",
        companyType: "",
        provinceName: "",
        cityName: "",
        status: "1",
        regionList: [],
      },
      form: {
        datalist: [],
      },
      pagination: {
        current: 1,
        pageSize: 10,
        totalPage: 0,
      },
      props: { multiple: true },
    };
  },
  async mounted() {
    this.getTableList();
  },
  created: function () {
    this.authOperation("Agency");
  },
  methods: {
    authOperation(curPage) {
      var that = this;
      var res = authOperationCheck(curPage);
      that.hasCreateAuth = res.hasCreateAuth;
      that.hasUpdateAuth = res.hasUpdateAuth;
      that.hasDeleteAuth = res.hasDeleteAuth;
      that.hasImportAuth = res.hasImportAuth;
      that.hasExportAuth = res.hasExportAuth;
    },
    handleAccredit(index, row) {},
    handleDelete(index, row) {},
    handleCurrentChange(val) {
      this.pagination.current = val;
      this.getTableList();
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.getTableList();
    },
    handleChange(val) {},
    showDialog(visible) {
      this.dialogAddClient = visible;
      if (visible) {
        this.clientform = {
          agencyName: "",
          agencyCode: "",
          customerCenter: "",
          regionId: "",
          address: "",
          companyType: "",
          provinceName: "",
          cityName: "",
          status: "1",
          regionList: [],
          brandCode:"",
        };
        if (this.$refs.addRef.$refs.airFormAdd != undefined) {
          this.$refs.addRef.$refs.airFormAdd.resetFields();
        }
        let brand = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR"
        this.$set(this.clientform, "brandCode", brand);
      }
    },
    async showEditDialog(visible, id) {
      this.dialogEditClient = visible;
      if (visible) {
        await this.getAgencyById(id);
        this.dialogEditMethoud=visible;
        if (this.$refs.editRef.$refs.airFormAdd != undefined) {
          this.$refs.editRef.$refs.airFormAdd.resetFields();
        }
      } else {
        this.dialogEditMethoud=visible;
        this.clientform = {
          agencyName: "",
          agencyCode: "",
          customerCenter: "",
          regionId: "",
          address: "",
          companyType: "",
          provinceName: "",
          cityName: "",
          status: "1",
          regionList: [],
          brandCode:"",
        };
        if (this.$refs.editRef.$refs.airFormAdd != undefined) {
          this.$refs.editRef.$refs.airFormAdd.resetFields();
        }
      }
    },
    async getAgencyById(e) {
      let that = this;
      let data = { id: e };
      let res = await getAgencyById(data);
      that.clientform = res.result;
    },
    add() {
      let that = this;
      addAgency(that.clientform)
        .then((res) => {
          that.dialogAddClient = false;
          that.$message({
            showClose: true,
            message: that.$t("tips.saveSuccess"),
            type: "success",
          });
          that.getTableList();
        })
        .catch((err) => {
          that.$message({
            showClose: true,
            message: err.error.message,
            type: "error",
          });
        });
    },
    update() {
      let that = this;
      updateAgency(that.clientform)
        .then((res) => {
          that.$message({
            showClose: true,
            message: that.$t("tips.updateSuccess"),
            type: "success",
          });
          that.dialogEditClient = false;
          that.getTableList();
          this.clientform = {
            agencyName: "",
            agencyCode: "",
            customerCenter: "",
            regionId: "",
            address: "",
            companyType: "",
            provinceName: "",
            cityName: "",
            status: "1",
            regionList: [],
          };
        })
        .catch((err) => {
          that.$message({
            showClose: true,
            message: err.error.message,
            type: "error",
          });
        });
    },
    deleteAge(e) {
      let that = this;
      let data = { id: e };
      deleteAgency(data)
        .then((res) => {
          that.$message({
            showClose: true,
            message: this.$t("tips.deleteSuccess"),
            type: "success",
          });
          that.getTableList();
        })
        .catch((err) => {
          that.$message({
            showClose: true,
            message: err.error.message,
            type: "error",
          });
        });
    },
    onSubmit() {},
    getTableList() {
      let that = this;
      let skipcount = (this.pagination.current - 1) * this.pagination.pageSize;
      let postData = {
        AgencyName: this.formselect.agencyName,
        State: this.formselect.state,
        SkipCount: skipcount,
        MaxResultCount: this.pagination.pageSize,
      };
      getAgencyList(postData).then((res) => {
        let data = res.result.items;
        this.pagination.totalPage = res.result.totalCount;
        that.tableData1 = data;
      });
    },
    showImportDialog(visible) {
      this.dialogImportClient = visible;
      this.form.datalist = [];
      if (this.$refs.importRef.$refs.airFormImport != undefined) {
        this.$refs.importRef.$refs.airFormImport.resetFields();
      }
    },
    exportCustomerList() {
      this.loading = true;
      let that = this;
      // var data = {
      //   Ccn: ccn,
      //   Version: version,
      // };
      // var headers = [
      //   { key: "agencyName", title: "经销商名称" },
      //   { key: "agencyCode", title: "经销商代码" },
      //   { key: "customerCenter", title: "客户中心" },
      //   { key: "companyType", title: "单位性质" },
      //   { key: "address", title: "地址" },
      //   { key: "CooperationStatus", title: "合作状态" },
      // ];
      var exportData = [
        [
          this.$t('desc.dealername'),
          this.$t('title.dealercode'),
          this.$t('title.brand'),
          this.$t('title.customerCenter'),
          this.$t('title.companyType'),
          this.$t('title.address'),
          this.$t('title.CooperationStatus'),
        ],
      ];

      var fileName = this.$t('exportContent.经销商列表导出')+".xlsx";
      let postData = {
        AgencyName: this.formselect.agencyName,
        State: this.formselect.state,
        SkipCount: 0,
        MaxResultCount: 100000,
      };
      getAgencyList(postData).then((res) => {
        if (res.result) {
          var data = res.result.items;
          //导入数据里有null会导致文件损坏
          const dataSource = data.map((item) => {
            Object.keys(item).forEach((key) => {
              // 后端传null node写入会有问题
              if (item[key] === null) {
                item[key] = "";
              }

              if (Array.isArray(item[key])) {
                item[key] = item[key].join(",");
              }
            });
            return item;
          });
          dataSource.forEach((item) => {
            let rowData = [];
            rowData = [
              item.agencyName,
              item.agencyCode,
              item.brandCode,
              item.customerCenter,
              this.$t("desc."+item.companyType),
              item.address,
              this.$t("desc."+item.stateName),
            ];
            exportData.push(rowData);
          });
          exportExcelNew(exportData, fileName);
          // exportExcel(headers, dataSource, fileName);
          this.loading = false;
        }
      });
    },
    uploadFile() {
      let that = this;
      this.importLoading = true;
      var datalist = that.form.datalist;
      var propertys = Object.keys(datalist[0]);

      var msgArr = [];
      var index = 2;
      var postData = [];
      let customerCharater = {
        "Directly Managed":"直管",
        "Distributor Managed":"经销商",
        "Service Distributor":"服务经销商",
        "Middleman":"中间商",
        "Others":"其他",
      }
      datalist.map((v) => {
        let obj = {};
        if (that.activeLang == "en") {
          obj.AgencyName = v["Customer Name"];
          obj.AgencyCode = v["Customer Code"];
          obj.CustomerCenter = v["Customer Center"];
          obj.CompanyType = customerCharater[v["Customer Charater"]];
          obj.Status = v["Status"];
          obj.BrandCode = v["Brand"];
        } else {
          obj.AgencyName = v["公司名称"];
          obj.AgencyCode = v["公司代码"];
          obj.CustomerCenter = v["客户中心"];
          obj.CompanyType = v["单位性质"];
          obj.Status = v["状态"];
          obj.BrandCode = v["品牌"];
        }
        
        var msg = "";
        if (obj.AgencyCode == undefined || obj.AgencyCode == "") {
          msg = that.$t("importError.companyCodeIsEmpty");
        }
        if (obj.AgencyName == undefined || obj.AgencyName == "") {
          msg += that.$t("importError.companyNameIsEmpty");
        }
        if (msg != "") {
          msgArr.push(that.$t("importError.exceptionLine") + index + that.$t("importError.行异常:") + msg);
        } else {
          if (that.find(postData, obj) > -1) {
            msgArr.push(
              that.$t("importError.exceptionLine") +
                index +
                that.$t("importError.行异常:")+
                that.$t("importError.theSameCustomerCodeAlreadyExists") +
                obj.AgencyCode
            );
          } else {
            postData.push(obj);
          }
        }
        index++;
      });
      if (msgArr.length > 0) {
        that.$message({
          showClose: true,
          dangerouslyUseHTMLString: true,
          message: msgArr.join("<br/>"),
          type: "error",
        });
        return false;
      }
      importAgency(postData, 2 * 60 * 1000)
        .then((res) => {
          this.importLoading = false;
          that.dialogImportClient = false;
          that.$message({
            showClose: true,
            message: that.$t("tips.importSuccess"),
            type: "success",
          });
          that.getTableList();
        })
        .catch((err) => {
          that.$message({
            showClose: true,
            message: err.error.message,
            type: "error",
          });
        });
    },
    find(array, model) {
      var index = array.findIndex(
        (item) => item.AgencyCode === model.AgencyCode
      );
      return index; // -1 说明array中不存在id为str的对象
    },
    resetKeyword() {
      this.formselect.state = "0";
      this.formselect.agencyName = "";
    },
  },
};
</script>
